import React, { createContext, cloneElement, createRef, useState, useEffect } from 'react';
import SweetScroll from 'sweet-scroll';

import { AccordionSection } from './section';
import { getCollapsedSectionHeight } from './helper';
import { detectSuccessfulPaymentURL } from '@/utils/helper';

import './_accordion.scss';

const AccordionContext = createContext<any>(null);
const HEADER_HEIGHT_PX = 96;

const Accordion = (props: any) => {
  const [activeSectionIndex, setActiveSectionIndex] = useState(0);
  const [neverBypassActiveSection, setNeverBypassActiveSection] = useState(false);
  const [sectionRefs, setSectionRefs] = useState([]) as any;
  const accordionRef = createRef<HTMLDivElement>();
  const scroller = new SweetScroll({ offset: -HEADER_HEIGHT_PX });

  const setSectionRef = (sectionRef: any) => {
    sectionRefs.push(sectionRef);
    setSectionRefs([...sectionRefs]);
  };
  useEffect(() => {
    scroller.destroy();
    
    if (detectSuccessfulPaymentURL(window.location)) {
      //Should correspond with payment step
      setActiveSectionIndex(3);
    }
  }, []);
  const scrollToNextSection = () => {
    setTimeout(() => {
      const collapsedSectionHeight = getCollapsedSectionHeight(sectionRefs);
      const accordionPosition =
        accordionRef.current && accordionRef.current.getBoundingClientRect().top + window.scrollY;
      const positionToScrollTo =
        accordionPosition && accordionPosition + collapsedSectionHeight * activeSectionIndex;
      scroller.to(positionToScrollTo);
    }, 0);
  };

  const activateNextSection = () => {
    setActiveSectionIndex(() => {
      return activeSectionIndex + 1;
    });
    setNeverBypassActiveSection(false);
    scrollToNextSection();
  };

  const activateSection = (sectionIndex: any) => {
    setActiveSectionIndex(sectionIndex);
    setNeverBypassActiveSection(true);
  };

  const sections = props.children.props.children;
  const sectionsToRender = React.Children.toArray(sections).filter((section) => section);

  return (
    <div className="component-accordion" ref={accordionRef}>
      <AccordionContext.Provider
        value={{
          activeSectionIndex,
          neverBypassActiveSection
        }}
      >
        {sectionsToRender.map((section: any, index) =>
          cloneElement(section, {
            sectionIndex: index,
            onHeaderClick: activateSection,
            onCompletion: activateNextSection,
            setSectionRef
          })
        )}
      </AccordionContext.Provider>
    </div>
  );
};

export { Accordion, AccordionSection, AccordionContext };
